// T178 listed requests: which flagged users are blocked by the department rule or are Not Found,
// and the "Please read" wording for them (validation popup + blue box). Pure (node-testable); imports
// use the extension so node can import them too.
import { rowBlocked } from './eligibility.js';
import { normalizeAlias } from './alias.js';

const isNotFound = (row) => String((row && row.eligible) || '').includes('Not Found');

// rows: validationResults.tableData (after applyEligibility). serverBlocked: the storeResults
// DEPARTMENT_* / USER_NOT_FOUND refusal users ([{login, match}]) or null.
// mode: 'none'  -> no department-blocked user (callers keep today's text, unchanged)
//       'all'   -> every Not Eligible user is department-blocked
//       'mixed' -> some department-blocked, some Not Eligible for other reasons
// notFound / notFoundLogins: listed only, the Not Found users (blocked; unlisted keeps today's text).
// allBlocked: every flagged user is blocked (department or Not Found) and none is Not Eligible otherwise.
export function summarizeFlagged(rows, isListed, serverBlocked) {
    const server = {};
    if (isListed) (serverBlocked || []).forEach(u => { if (u && u.login) server[normalizeAlias(u.login)] = u.match || 'MISMATCH'; });
    let mismatch = 0, unknown = 0, other = 0;
    const notFoundLogins = [];
    (rows || []).forEach(r => {
        if (!r) return;
        const s = server[normalizeAlias(r.login)];
        if (isNotFound(r) || s === 'NOT_FOUND') {
            if (isListed) notFoundLogins.push(r.login);
            return;
        }
        const blocked = rowBlocked(r, isListed);
        if (blocked || s !== undefined) {
            if ((blocked ? r.departmentMatch : s) === 'UNKNOWN') unknown++; else mismatch++;
        } else if (!r.eligibleBool) {
            other++;
        }
    });
    const deptBlocked = mismatch + unknown;
    const mode = deptBlocked === 0 ? 'none' : (other === 0 ? 'all' : 'mixed');
    const notFound = notFoundLogins.length;
    const allBlocked = deptBlocked + notFound > 0 && other === 0;
    return { mode, mismatch, unknown, deptBlocked, other, notFound, notFoundLogins, allBlocked };
}

// Listed requests: the Not Found users can't be added (replaces the "temporary sync delay" text there).
export function notFoundBlockedLine(logins) {
    const list = (logins || []).filter(Boolean);
    return `We couldn't find ${list.length} user(s) in our directory: ${list.join(', ')}. Check the alias (typos, people who have left), or request their access through My team is not listed (unlisted use case).`;
}

// Popup lead line when every flagged user is department-blocked (no Not Found, no other reason).
export const DEPT_ONLY_LEAD = "Some users in your request can't be added to this approved use case.";

// The department part: one line for "not on the team's list", one for "department not confirmed".
export function deptBlockedLines(summary, teamLabel) {
    const lines = [];
    if (summary.mismatch > 0) {
        lines.push(`${summary.mismatch} user(s) are in departments that aren't part of the ${teamLabel} approved use case and can't be added to this request. Remove them, or start an unlisted request for them.`);
    }
    if (summary.unknown > 0) {
        lines.push(`${summary.unknown} user(s) can't be added to this request because we couldn't confirm their department. Re-validate, contact CTPS, or use the unlisted path.`);
    }
    return lines;
}

// Mixed case: today's justification wording, scoped to (and counting) the non-department users only.
export function otherIneligibleText(n) {
    return `${n} other user${n !== 1 ? 's are' : ' is'} marked "Not Eligible" for another reason (such as inactivity, Base PI or job level). If you believe this is incorrect, you can still select the user and submit; you'll be asked to add a short justification and our team will review.`;
}
